const STORAGE_PREFIX = "videoTeaserDismiss"
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000

interface VideoTeaserDismissState {
    expiresAt: number
}

const getStorageKey = (mediaVideoId: string) => `${STORAGE_PREFIX}:${mediaVideoId}`

export const isVideoTeaserDismissed = (mediaVideoId: string): boolean => {
    if (!mediaVideoId || typeof window === "undefined" || typeof window.localStorage === "undefined") {
        return false
    }

    try {
        const raw = window.localStorage.getItem(getStorageKey(mediaVideoId))
        if (!raw) {
            return false
        }
        const parsed = JSON.parse(raw) as VideoTeaserDismissState
        if (!parsed || !parsed.expiresAt || parsed.expiresAt < Date.now()) {
            window.localStorage.removeItem(getStorageKey(mediaVideoId))
            return false
        }
        return true
    } catch (e) {
        return false
    }
}

export const dismissVideoTeaser = (mediaVideoId: string, ttlMs: number = DEFAULT_TTL_MS): void => {
    if (!mediaVideoId || typeof window === "undefined" || typeof window.localStorage === "undefined") {
        return
    }

    try {
        const state: VideoTeaserDismissState = {
            expiresAt: Date.now() + ttlMs,
        }
        window.localStorage.setItem(getStorageKey(mediaVideoId), JSON.stringify(state))
    } catch (e) {
    }
}
